import { ReactNode } from "react";
import { ViewerProvider } from "@/shared/lib/pdf-viewer";

export function withPdfViewer(node: ReactNode) {
  return <ViewerProvider>{node}</ViewerProvider>;
}
